import settings from '@settings'
import { configuration } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { CoreButton } from '../CoreButton'

import './FinalyRejectedModal.scss'

interface FinallyRejectedProps {
  setCookie: any
  cookieConsent?: any
}

export const FinallyRejectedModal = ({ setCookie }: FinallyRejectedProps) => {
  return (
    <div className='finally-rejected-modal-wrapper'>
      <span>
        {tr(
          'FRONTEND.BANKING.COMMON.ACCOUNT_REJECTED',
          'Please contact Customer Service to get support on your account verification.'
        )}
      </span>
      <CoreButton
        text={tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
        fullWidth
        size='large'
        onClick={() => {
          const aYearFromNow = new Date()
          aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)

          setCookie(
            'cookie.modals',
            JSON.stringify({
              finallyRejectedShown: true
            }),
            {
              expires: aYearFromNow,
              maxAge: 31536000,
              domain: configuration.isLocal() ? null : settings.cookieDomain
            }
          )
        }}
      />
    </div>
  )
}
